var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.97717 12.9375C1.97717 12.9375 5.97717 4.9375 12.9772 4.9375C19.9772 4.9375 23.9772 12.9375 23.9772 12.9375C23.9772 12.9375 19.9772 20.9375 12.9772 20.9375C5.97717 20.9375 1.97717 12.9375 1.97717 12.9375Z",
    stroke: "#1BA0DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9772 15.9375C14.634 15.9375 15.9772 14.5944 15.9772 12.9375C15.9772 11.2806 14.634 9.9375 12.9772 9.9375C11.3203 9.9375 9.97717 11.2806 9.97717 12.9375C9.97717 14.5944 11.3203 15.9375 12.9772 15.9375Z",
    stroke: "#1BA0DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.977173 0.9375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.97a656377053ffc5d9f94ccb6718fa2c.svg";
export { ForwardRef as ReactComponent };